import React, { useState } from 'react';
import { CssBaseline, ThemeProvider, Box } from '@mui/material';
import ChatWindow from './components/ChatWindow';
import Navbar from './components/Navbar';
import FeatureSection from './components/FeatureSection';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import FloatingChatButton from './components/FloatingChatBtn';
import theme from './theme';

// Main App component
const App = () => {
  const [isFeatureSectionVisible, setIsFeatureSectionVisible] = useState(true);
  const [currentPage, setCurrentPage] = useState('landing'); // Manage page transitions

  // Hide the FeatureSection after the first message is sent
  const handleFirstMessageSent = () => {
    setIsFeatureSectionVisible(false);
  };

  // Handle "Get Started" click to navigate to the Login page
  const handleGetStartedClick = () => {
    setCurrentPage('login');
  };

  // Handle successful login to navigate to the Chat interface
  const handleLoginSuccess = () => {
    setCurrentPage('chat');
  };

  // Handle "Close" button click in Navbar to navigate to Login page
  const handleNavbarClose = () => {
    setCurrentPage('landing');
  };

  // Handle logout from the ChatWindow (triggered by the popup)
  const handleLogout = () => {
    setCurrentPage('login'); // Redirect to login after logout
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box variant="layoutContainer"> {/* Apply layoutContainer variant */}
        {/* Conditional Rendering based on the current page */}
        {currentPage === 'landing' && <LandingPage onGetStarted={handleGetStartedClick} />}
        {currentPage === 'landing' && <FloatingChatButton onGetStarted={handleGetStartedClick} />}
        {currentPage === 'login' && <Login onLoginSuccess={handleLoginSuccess} />}
        {currentPage === 'chat' && (
          <>
            <Box variant="header"> {/* Apply header variant */}
              <Navbar setCurrentPage={handleNavbarClose} />
            </Box>
            {/* Show FeatureSection only if it's set to be visible */}
            {isFeatureSectionVisible && <FeatureSection />}
            {/* Main chat area */}
            <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
              <ChatWindow onFirstMessage={handleFirstMessageSent} onLogout={handleLogout} />
            </Box>
          </>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default App;
